import { render, staticRenderFns } from "./manageWallet.vue?vue&type=template&id=6e8c3447&scoped=true&"
import script from "./manageWallet.vue?vue&type=script&lang=js&"
export * from "./manageWallet.vue?vue&type=script&lang=js&"
import style0 from "./manageWallet.vue?vue&type=style&index=0&id=6e8c3447&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c3447",
  null
  
)

export default component.exports